import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { router } from './app/router.js';
import { componentTheme } from './styles/componentTheme.css.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <div className={componentTheme}>
      <RouterProvider router={router} />
    </div>
  </StrictMode>,
);
